<template>
  <div>
    <div class="container-fluid">
      <vx-card
        title="Cesiones y Permutas del MS"
        subtitle-color="dark"
        subtitle="Selecciona la fecha para la obtención de los datos y la descarga del archivo"
        class="mt-3"
      >
        <div class="vx-row">
          <div class="vx-col md:w-1/4 xl:w-1/3 w-full mb-2">
            <label>Fecha</label>
            <datepicker
              placeholder="Fecha"
              :language="es"
              v-model="dateForFile"
              format="dd/MM/yyyy"
              :disabledDates="disabledDates"
              />
          </div>
          <div class="vx-col md:w-1/4 xl:w-1/3 w-full mb-2">
            <vs-button
              class="mt-6"
              color="success"
              @click="generateFile()"
              >Descargar</vs-button
            >
          </div>
        </div>
      </vx-card>

    </div>
  </div>
</template>

<script lang="js">
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";

export default  {
    name: 'secondary-market-swaps',
    props: [],
    components: {
      Datepicker,
  },
    data() {
      return {
        es:es,
        dateForFile: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      ),
        disabledDates: {
        from: new Date(),
      },
      }
    },
    methods: {
      async generateFile(){
      try {
        let url = `${this.ApiDomain}/api/admin-download-secondary-market-swaps/${this.dateForFile.toISOString().slice(0, 10)}?access_token=${this.AccessToken}`;
        window.open(url, "_blank");
      } catch (e) {
        this.warn(e)
        this.showError(e);
      }
    },
    }
}
</script>